<div class="box">
    <div class="py-5 ps-5 pe-3">
        <!-- Go Back -->
        <div class="mb-5">
            <a
                [ariaLabel]="'v3-button-close' | translate"
                [attr.tabIndex]="0"
                [routerLink]="goBackLink"
                class="go-back-link inline pointer"
                linkDataTest="goBackLink"
            >
                <app-icon name="x" class="tw-w-6 tw-h-6"></app-icon>
            </a>
        </div>

        <!-- Two Columns -->
        <div class="row mb-5">
            <div class="position-relative">
                <!-- Leaderboard -->
                <div class="mb-4">
                    <app-leaderboard [name]="leaderboardName"></app-leaderboard>
                </div>
            </div>
        </div>
    </div>
</div>
